/**
 * Список территорий
 */
import { Pagination } from '@n3/ng-api-common';
import { TerritoryShort } from './territoryShort.model';
export class TerritoryList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: TerritoryShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new TerritoryShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
